import { createEmptyAction, createPayloadAction } from "../utility/actions";

const MANAGE_REPAYMENT_POST_APPLICATION = "MANAGE_REPAYMENT_POST_APPLICATION";
const MANAGE_REPAYMENT_MERGE_INITIAL_FIELD_VALUE = "MANAGE_REPAYMENT_MERGE_INITIAL_FIELD_VALUE";
const MANAGE_REPAYMENT_REMOVE_PENDING_FIELD = "MANAGE_REPAYMENT_REMOVE_PENDING_FIELD";
const MANAGE_REPAYMENT_RESET_FORM = "MANAGE_REPAYMENT_RESET_FORM";
const MANAGE_REPAYMENT_POST_LOAN_FORM_START = "MANAGE_REPAYMENT_POST_LOAN_FORM_START";
const MANAGE_REPAYMENT_POST_LOAN_FORM_SUCCESS = "MANAGE_REPAYMENT_POST_LOAN_FORM_SUCCESS";
const MANAGE_REPAYMENT_POST_LOAN_FORM_ERROR = "MANAGE_REPAYMENT_POST_LOAN_FORM_ERROR";
const MANAGE_REPAYMENT_CLEAR_ERROR = "MANAGE_REPAYMENT_CLEAR_ERROR";
const MANAGE_REPAYMENT_VALIDATE_FORM = "MANAGE_REPAYMENT_VALIDATE_FORM";
const MANAGE_REPAYMENT_INVALIDATE_FORM = "MANAGE_REPAYMENT_INVALIDATE_FORM";
const MANAGE_REPAYMENT_GET_PAYMENT_CARD_DATA = "MANAGE_REPAYMENT_GET_PAYMENT_CARD_DATA";
const MANAGE_REPAYMENT_GET_PAYMENT_CARD_SUCCESS = "MANAGE_REPAYMENT_GET_PAYMENT_CARD_SUCCESS";
const MANAGE_REPAYMENT_GET_PAYMENT_CARD_FAILED = "MANAGE_REPAYMENT_GET_PAYMENT_CARD_FAILED";
const EZIDEBIT_PAYMENT_RESPONSE = "EZIDEBIT_PAYMENT_RESPONSE";
const RESET_CARD_DATA_STATUS = "RESET_CARD_DATA_STATUS";
const FETCHING_CARD_DATA = "FETCHING_CARD_DATA";
const CARD_ON_FILE = "CARD_ON_FILE";

const actions = {
  MANAGE_REPAYMENT_POST_APPLICATION,
  MANAGE_REPAYMENT_MERGE_INITIAL_FIELD_VALUE,
  MANAGE_REPAYMENT_REMOVE_PENDING_FIELD,
  MANAGE_REPAYMENT_RESET_FORM,
  MANAGE_REPAYMENT_POST_LOAN_FORM_START,
  MANAGE_REPAYMENT_POST_LOAN_FORM_SUCCESS,
  MANAGE_REPAYMENT_POST_LOAN_FORM_ERROR,
  MANAGE_REPAYMENT_CLEAR_ERROR,
  MANAGE_REPAYMENT_VALIDATE_FORM,
  MANAGE_REPAYMENT_INVALIDATE_FORM,
  MANAGE_REPAYMENT_GET_PAYMENT_CARD_DATA,
  MANAGE_REPAYMENT_GET_PAYMENT_CARD_SUCCESS,
  MANAGE_REPAYMENT_GET_PAYMENT_CARD_FAILED,
  EZIDEBIT_PAYMENT_RESPONSE,
  RESET_CARD_DATA_STATUS,
  FETCHING_CARD_DATA,
  CARD_ON_FILE,
  resetCardData: createEmptyAction(RESET_CARD_DATA_STATUS),
  setEzidebitPaymentResponse: createPayloadAction(EZIDEBIT_PAYMENT_RESPONSE),
  getPaymentCardData: createPayloadAction(MANAGE_REPAYMENT_GET_PAYMENT_CARD_DATA),
  getPaymentCardDataSuccess: createPayloadAction(MANAGE_REPAYMENT_GET_PAYMENT_CARD_SUCCESS),
  getPaymentCardDataFailed: createEmptyAction(MANAGE_REPAYMENT_GET_PAYMENT_CARD_FAILED),
  markFormAsValid: createEmptyAction(MANAGE_REPAYMENT_VALIDATE_FORM),
  markFormAsInvalid: createEmptyAction(MANAGE_REPAYMENT_INVALIDATE_FORM),
  postRequest: createPayloadAction(MANAGE_REPAYMENT_POST_APPLICATION),
  postLoanFormStart: createEmptyAction(MANAGE_REPAYMENT_POST_LOAN_FORM_START),
  postLoanFormSuccess: createEmptyAction(MANAGE_REPAYMENT_POST_LOAN_FORM_SUCCESS),
  postLoanFormError: createPayloadAction(MANAGE_REPAYMENT_POST_LOAN_FORM_ERROR),
  setFieldInitialValue: createPayloadAction(MANAGE_REPAYMENT_MERGE_INITIAL_FIELD_VALUE),
  removePendingField: createPayloadAction(MANAGE_REPAYMENT_REMOVE_PENDING_FIELD),
  resetForm: createEmptyAction(MANAGE_REPAYMENT_RESET_FORM),
  clearError: createEmptyAction(MANAGE_REPAYMENT_CLEAR_ERROR),
  cardIsFetching: createEmptyAction(FETCHING_CARD_DATA),
  cardOnFile: createPayloadAction(CARD_ON_FILE),
};

export default actions;
